import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m6.905 12.67 2.882-7.602h1.33L14 12.67h-1.33l-.681-1.932H8.916l-.68 1.932zM1.9 10.77l-.886-.888 3.199-3.199a7.3 7.3 0 0 1-1.006-1.267 11 11 0 0 1-.831-1.615h1.33q.317.617.633 1.077.318.459.76.918.523-.522 1.086-1.465a9.2 9.2 0 0 0 .847-1.797H0V1.267h4.434V0h1.267v1.267h4.435v1.267H8.299q-.333 1.14-.998 2.344-.666 1.204-1.315 1.837l1.52 1.552-.474 1.299L5.1 7.586zm7.412-1.141h2.28l-1.14-3.23z"
    }, null, -1)
  ]))]))
}
export default { render: render }